import { GameObject, Vector2, Rectangle } from '../../../types/game.types';
import { RenderManager } from '../../../core/RenderManager';
import { AudioManager } from '../../../core/AudioManager';

export class Bullet implements GameObject {
  public id: string;
  public position: Vector2;
  public velocity: Vector2;
  public size: Vector2;
  public active: boolean = true;
  public radius: number = 2;

  private renderManager: RenderManager;
  private audioManager: AudioManager;
  private gameWidth: number;
  private gameHeight: number;
  private lifespan: number;
  private maxLifespan: number = 2.0; // 2 seconds max
  private isEnemy: boolean;

  constructor(
    id: string,
    x: number,
    y: number,
    velocityX: number,
    velocityY: number,
    isEnemyBullet: boolean,
    renderManager: RenderManager,
    audioManager: AudioManager,
    gameWidth: number,
    gameHeight: number
  ) {
    this.id = id;
    this.position = { x, y };
    this.velocity = { x: velocityX, y: velocityY };
    this.size = { x: 4, y: 4 };
    this.renderManager = renderManager;
    this.audioManager = audioManager;
    this.gameWidth = gameWidth;
    this.gameHeight = gameHeight;
    this.lifespan = 0;
    this.isEnemy = isEnemyBullet;
  }

  public update(deltaTime: number): void {
    // Update lifespan
    this.lifespan += deltaTime;
    if (this.lifespan >= this.maxLifespan) {
      this.active = false;
      return;
    }

    // Update position
    this.position.x += this.velocity.x * deltaTime;
    this.position.y += this.velocity.y * deltaTime;

    // Wraparound screen edges
    this.wrapAroundScreen();
  }

  private wrapAroundScreen(): void {
    if (this.position.x < -this.size.x) {
      this.position.x = this.gameWidth;
    } else if (this.position.x > this.gameWidth) {
      this.position.x = -this.size.x;
    }

    if (this.position.y < -this.size.y) {
      this.position.y = this.gameHeight;
    } else if (this.position.y > this.gameHeight) {
      this.position.y = -this.size.y;
    }
  }

  public render(ctx: CanvasRenderingContext2D): void {
    if (!this.active) return;

    const centerX = this.position.x + this.size.x / 2;
    const centerY = this.position.y + this.size.y / 2;

    // Draw bullet as a small square
    const color = this.isEnemy ? '#FF0000' : '#FFFFFF'; // Red for enemy, white for player
    this.renderManager.fillRect(
      centerX - 1,
      centerY - 1,
      2,
      2,
      color
    );
  }

  public getBounds(): Rectangle {
    return {
      x: this.position.x,
      y: this.position.y,
      width: this.size.x,
      height: this.size.y
    };
  }

  public destroy(): void {
    this.active = false;
  }

  public isEnemyBullet(): boolean {
    return this.isEnemy;
  }
}